import { render, staticRenderFns } from "./Complience.vue?vue&type=template&id=2150b4b8&scoped=true"
import script from "./Complience.vue?vue&type=script&lang=js"
export * from "./Complience.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2150b4b8",
  null
  
)

export default component.exports